import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4ThreadStartEventProps extends GA4GeneralProps {
  threadId: string
  featureClass?: string | null
  selectedOption?: string | null
  threadClass?: string | null
}

export class GA4ThreadStartEvent extends GA4Event {
  ga4_thread_id: GA4ThreadStartEventProps['threadId']
  ga4_feature_class: GA4ThreadStartEventProps['featureClass']
  ga4_selected_option: GA4ThreadStartEventProps['selectedOption']
  ga4_thread_class: GA4ThreadStartEventProps['threadClass']

  constructor({
    threadId,
    featureClass = null,
    selectedOption = null,
    threadClass = null,
    ...generalProps
  }: GA4ThreadStartEventProps) {
    super({ event: EVENT.THREAD_START, ...generalProps })

    this.ga4_thread_id = threadId
    this.ga4_feature_class = featureClass
    this.ga4_selected_option = selectedOption
    this.ga4_thread_class = threadClass
  }
}
